<template>
  <div class="vld-parent">
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div
        class="container-fluid align-items-center vld-parent"
        ref="partners_container"
      >
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode conferir os principais benefícios das aceleradas
              Stars. A listagem abaixo será atualizada conforme novas parcerias
              sejam firmadas.
            </p>
          </div>
        </div>
      </div>
      <div class="row"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div v-if="control.empty" class="row">
        <div class="col-12 mb-1 text-center">
          <badge type="info" class="bg-white">
            Não existem parcerias cadastradas até o momento
          </badge>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-12">
          <div class="card-deck">
            <div
              class="col-lg-4 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="partner in partners"
              :key="partner.id"
            >
              <div class="card text-center flex-grow-1">
                <div class="card-profile-image">
                  <img
                    :src="partner.image_url"
                    class="card-image my-3"
                    alt="..."
                  />
                </div>
                <div class="card-body mt-8 pt-0 pb-3">
                  <h2 class="mb-2 card-title text-orange">
                    {{ partner.name }}
                  </h2>
                  <div>
                    <p class="description font-weight-bold mt-1 mb-2">
                      <badge type="primary" title="Categoria do benefício">{{
                        partner.category
                      }}</badge>
                    </p>
                  </div>
                </div>
                <div class="card-footer text-center">
                  <base-button
                    type="warning"
                    size="sm"
                    @click="handleOpenModalView(partner)"
                    ><i class="fas fa-eye mr-2"></i> Mais detalhes</base-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="!control.empty">
        <div class="col-lg-12 mb-3 text-right">
          <p class="text-muted">
            Exibindo
            <span class="font-weight-bold">{{ partners.length }}</span> de um
            total de
            <span class="font-weight-bold">{{ control.total }}</span>
            benefícios cadastrados.
          </p>
        </div>
        <div class="col-lg-12">
          <base-pagination
            :pageCount="control.lastPage"
            :perPage="control.limit"
            :value="control.page"
            size="md"
            align="center"
            @input="handlePageInput"
          />
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalView.show"
      modal-classes="modal-dialog-centered modal-lg"
      body-classes="pb-0"
      header-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Detalhes do benefício
      </h6>
      <div class="text-center">
        <div class="pb-2 card-profile-image">
          <img :src="modalView.partner.image_url" class="card-image my-3" />
        </div>
      </div>
      <div class="text-center">
        <h3 class="mt-7 pt-4">
          {{ modalView.partner.name }}
          <base-button
            type="link"
            v-if="modalView.partner.link"
            @click="openLink(modalView.partner.link)"
            title="Abrir link externo"
            class="p-0 m-0 ml-1 mt--1"
          >
            <i class="fas fa-link"></i>
          </base-button>
        </h3>
        <p class="description">
          <span class="font-weight-bold">Categoria:</span>
          {{ modalView.partner.category }}
        </p>
      </div>
      <div v-if="modalView.partner.benefit">
        <p class="description mb-0 mt-2">
          <span class="font-weight-bold">Benefícios</span>
        </p>
        <quill-editor
          v-model="modalView.partner.benefit"
          :options="editorReadOnly"
          disabled="disabled"
          class="border rounded"
        ></quill-editor>
      </div>
      <div v-if="modalView.partner.instructions">
        <p class="description mb-0 mt-2">
          <span class="font-weight-bold">Instruções</span>
        </p>
        <quill-editor
          v-model="modalView.partner.instructions"
          :options="editorReadOnly"
          disabled="disabled"
          class="border rounded"
        ></quill-editor>
      </div>
      <div class="mt-3">
        <p class="text-right description mt-3 mb-0">
          Última atualização em
          {{ formatTimestamp(modalView.partner.updated_at, "lll") }}.
        </p>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="dark"
          class="ml-auto"
          @click="modalView.show = false"
        >
          Voltar
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import api from "@/services/api";

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      partners: [],
      control: {
        page: 1,
        limit: 10,
        lastPage: 0,
        total: 0,
        empty: "",
      },
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble",
      },
      modalView: {
        show: false,
        partner: "",
      },
    };
  },
  async mounted() {
    await this.loadPartners(this.control.page);
  },
  methods: {
    async loadPartners(page) {
      const loader = this.$loading.show({
        container: this.$refs.partners_container,
        width: 150,
        height: 150,
        opacity: 0,
      });
      try {
        const { data: partners } = await api.get(
          `/startup-acl-partners?page=${page}&limit=${this.control.limit}`
        );
        this.control.lastPage = partners.lastPage;
        this.control.total = partners.total;
        this.control.page = partners.page;
        partners.data.forEach((partner) => {
          if (!partner.image_url)
            partner.image_url = "/img/pages/default_logo.png";
        });
        this.partners = partners.data;
        this.control.empty = partners.total <= 0;
        loader.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar os benefícios");
      }
    },
    async handlePageInput(page) {
      await this.loadPartners(page);
    },
    async handleOpenModalView(partner) {
      this.modalView.partner = partner;
      this.modalView.show = true;
    },
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 150px;
  height: 150px;
  border-radius: 10%;
  margin: auto;
}
</style>
<style>
.nv-container-read-only .quill-editor .ql-container,
.nv-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 10rem;
  width: 100%;
}
p > strong {
  font-weight: bold !important;
}
</style>
